import { getMarket } from './helpers';

const getRegistrationData = (args) => {
    const market = getMarket(args);
    return {
        tags: ['bot', 'registration'],
        additionalData: {
            rynek: market,
            'numer klienta': args.userIdentificationNumber ? args.userIdentificationNumber : '',
            'numer MSISDN': args.msisdn ? args.msisdn : ''
        }
    };
};

export default getRegistrationData;
